/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate200,
  GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate401,
  GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate403,
  GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate404,
  GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate500,
  GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificatePathParams,
  GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificateQueryResponse,
} from "../../types/documentCourseRegistrationController/GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate.ts";

export const getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificatePathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificatePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate200Schema =
  z.instanceof(
    File,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate401Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate401>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate403Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate403>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate404Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate500Schema =
  z.any() as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate500>;

export const getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificateQueryResponseSchema =
  z.lazy(
    () =>
      getApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificate200Schema,
  ) as unknown as ToZod<GetApiV1DocumentCourseRegistrationCourseregistrationidMonographCertificateQueryResponse>;
